import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';

import VisualizerClearAllButton from '../VisualizerClearAllButton/VisualizerClearAllButton';
import DragContainer from './DragContainer';
import CustomDragLayer from './CustomDragLayer';
import { IconCollapse, IconEnlarge } from '../Icons';
import { checkIfTouchDevice } from '../../Utils/VisualizerUtils';

import { StyledVisualizerWrapper } from '../BedVisualizerGallery/BedVisualizerGalleryStyles';
import { StyledMinimizeButton, StyledWallVisBackground } from './WallVisualizerGalleryStyles';

var wallVisualizerReducer = function wallVisualizerReducer(state, action) {
  switch (action.type) {
    case 'BOX_DRAG_START':
      return Object.assign({}, state, {
        isDragging: true
      });

    case 'BOX_DRAG_END':
      return Object.assign({}, state, {
        isDragging: false
      });

    case 'REMOVE_BOX_BY_VARIANT_ID':
      return Object.assign({}, state, {
        removeProduct: action.variantId
      });

    case 'BOX_REMOVED':
      return state.removeProduct !== null ? Object.assign({}, state, {
        removeProduct: null
      }) : state;

    case 'SET_STRING_LIGHTS_IMG':
      return Object.assign({}, state, {
        stringLightsImg: action.img
      });
    default:
      return state;
  }
};

var _ref = React.createElement(CustomDragLayer, null);

var _ref2 = React.createElement(IconCollapse, null);

var _ref3 = React.createElement(IconEnlarge, null);

var WallVisualizerGallery = function WallVisualizerGallery(props) {
  var _useReducer = useReducer(wallVisualizerReducer, {
    isDragging: false,
    removeProduct: null,
    stringLightsImg: ''
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var selectedProducts = props.selectedProducts,
      handleProductSelection = props.handleProductSelection,
      setBackground = props.setBackground;

  // set background on load and if user selects wallpaper

  useEffect(function () {
    var wallpaper = selectedProducts.find(function (prod) {
      return prod.category === 'wallpaper';
    });
    if (wallpaper) {
      setBackground(wallpaper.visualizerImages[0]);
    } else {
      setBackground('https://cdn.shopify.com/s/files/1/1765/3959/files/Wall_Visualizer_Base.jpg?v=1589918427');
    }
  }, [setBackground, selectedProducts]);

  useEffect(function () {
    var stringLights = selectedProducts.find(function (prod) {
      return prod.category === 'string-lights';
    });
    if (stringLights) {
      dispatch({
        type: 'SET_STRING_LIGHTS_IMG',
        img: stringLights.visualizerImages[0]
      });
    } else {
      dispatch({ type: 'SET_STRING_LIGHTS_IMG', img: '' });
    }
  }, [selectedProducts]);

  useEffect(function () {
    if (state.removeProduct) {
      var removeMe = selectedProducts.find(function (prod) {
        return prod.variantId === state.removeProduct;
      });
      handleProductSelection(removeMe);
      dispatch({ type: 'BOX_REMOVED' });
    }
  }, [state.removeProduct, selectedProducts, handleProductSelection]);

  var backend = checkIfTouchDevice() ? TouchBackend : HTML5Backend;

  var isSmallThumbnail = !props.largeThumbnail && props.stickyMobileGallery && props.windowWidth < 769;

  var handleMinimizeButtonClick = function handleMinimizeButtonClick(e) {
    // prevent double click since we are also clicking StyledVisualizerWrapper
    e.stopPropagation();
    props.setLargeThumbnail(!props.largeThumbnail);
  };

  return React.createElement(
    StyledVisualizerWrapper,
    {
      className: 'visualizer',
      onClick: function onClick() {
        return props.setLargeThumbnail(true);
      },
      stickyMobileGallery: props.stickyMobileGallery,
      largeThumbnail: props.largeThumbnail
    },
    React.createElement(StyledWallVisBackground, {
      src: props.background,
      alt: 'Wall visualizer Background'
    }),
    state.stringLightsImg !== '' && React.createElement(StyledWallVisBackground, {
      src: state.stringLightsImg,
      alt: 'StringLights'
    }),
    React.createElement(
      DndProvider,
      { backend: backend },
      React.createElement(DragContainer, {
        selectedProducts: props.selectedProducts,
        dispatch: dispatch,
        state: state,
        isSmallThumbnail: isSmallThumbnail,
        queryParams: props.queryParams,
        windowWidth: props.windowWidth
      }),
      _ref
    ),
    React.createElement(
      StyledMinimizeButton,
      {
        enabled: props.stickyMobileGallery && props.windowWidth < 769,
        isSmallThumbnail: isSmallThumbnail,
        onClick: handleMinimizeButtonClick
      },
      props.largeThumbnail ? _ref2 : _ref3
    ),
    React.createElement(VisualizerClearAllButton, {
      selectedProducts: props.selectedProducts,
      largeThumbnail: props.largeThumbnail,
      windowWidth: props.windowWidth,
      handleClearAll: props.handleClearAll
    })
  );
};

WallVisualizerGallery.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  handleProductSelection: PropTypes.func.isRequired,
  stickyMobileGallery: PropTypes.bool.isRequired,
  largeThumbnail: PropTypes.bool.isRequired,
  setLargeThumbnail: PropTypes.func.isRequired,
  windowWidth: PropTypes.number.isRequired,
  queryParams: PropTypes.string,
  setBackground: PropTypes.func.isRequired,
  background: PropTypes.string.isRequired,
  handleClearAll: PropTypes.func.isRequired
};

export default WallVisualizerGallery;